import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import { useState } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { ShowAppBar, setJsonRsl } from "../../Redux/Action";
import { useEffect } from "react";
import { fetchRSLData } from "../Services/api";
import { useSelector, useDispatch } from "react-redux";
import { CircularProgress } from "@mui/material";

const Rsl = (props) => {
  const [showdetails, setShowDetails] = useState(false);
  const [selectedTick, setselectedTick] = useState(null);
  const isLoading = useSelector((state) => state.isLoading);

  const jsonData = useSelector((state) => state.jsonRSL);

  const selectedExchange = useSelector((state) => state.SetExchange);
  const selecttimeFrame = useSelector((state) => state.ActiveButton);
  const SelectedDropdown = useSelector((state) => state.SelectedDropdownOption);
  const serachValue = useSelector((state) => state.searchvalue);
  const [filterData, setfilterData] = useState(null);
  const dispatch = useDispatch();
  useEffect(() => {
    if (
      SelectedDropdown === "RS_LEVEL_FIBBO" ||
      SelectedDropdown === "RS_LEVEL_CLASSIC"
    ) {
      fetchRSLData(
        selectedExchange,
        selecttimeFrame,
        SelectedDropdown,
        dispatch,
        setJsonRsl
      );
    }
  }, [selectedExchange, selecttimeFrame, SelectedDropdown, dispatch]);
 
 debugger // const jsonData = [
  //   {
  //     Exchange: "BSE",
  //     Values: [
  //       {
  //         Ticker: "07AGG",
  //         Pp: 7.08,
  //         ResistanceLevel1: 7.1,
  //         ResistanceLevel2: 7.11,
  //         ResistanceLevel3: 7.13,
  //         SupportLevel1: 7.07,
  //         SupportLevel2: 7.05,
  //         SupportLevel3: 7.04,
  //       },
  //       {
  //         Ticker: "07GPG",
  //         Pp: 1.0,
  //         ResistanceLevel1: 1.0,
  //         ResistanceLevel2: 1.0,
  //         ResistanceLevel3: 1.0,
  //         SupportLevel1: 1.0,
  //         SupportLevel2: 1.0,
  //         SupportLevel3: 1.0,
  //       },
  //       {
  //         Ticker: "07SDGG",
  //         Pp: 1.0,
  //         ResistanceLevel1: 1.0,
  //         ResistanceLevel2: 1.0,
  //         ResistanceLevel3: 1.0,
  //         SupportLevel1: 1.0,
  //         SupportLevel2: 1.0,
  //         SupportLevel3: 1.0,
  //       },
  //     ],
  //   },
  // ];
  const handleShowDetails = (details) => {
    setselectedTick(details);
    setShowDetails(true);
    dispatch(ShowAppBar(true));
  };

  const handleShowDetails1 = () => {
    debugger;
    setselectedTick(null);
    setShowDetails(false);
    dispatch(ShowAppBar(false));
  };
  // Function to filter array data
  const filterArrayData = (dataArray) => {
    debugger;
    return dataArray[0].Values.filter(
      (item) =>
        serachValue &&
        item.Ticker &&
        item.Ticker.trim()
          .toLowerCase()
          .includes(serachValue.trim().toLowerCase())
    );
  };
  const filterObjectData = (dataObject) => {
    if (dataObject && dataObject.Data) {
      return dataObject.Data.filter(
        (item) =>
          serachValue &&
          item.Ticker &&
          item.Ticker.trim()
            .toLowerCase()
            .includes(serachValue.trim().toLowerCase())
      );
    }
    return [];
  };
  const getFilteredData = () => {
    debugger;
    if (!jsonData) {
      return [];
    }

    if (Array.isArray(jsonData)) {
      return filterArrayData(jsonData);
    } else if (typeof jsonData === "object") {
      return filterObjectData(jsonData);
    }

    return [];
  };

  useEffect(() => {
    if (serachValue === "") {
      jsonData && jsonData.length !== 0 && setfilterData(jsonData[0].Values);
    } else {
      setfilterData(getFilteredData());
    }
  }, [jsonData, serachValue]);

  return (
    isLoading ? 
    <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'50vh'}}>
<CircularProgress />

    </div>
    :
    <div>
      {!showdetails ? (
        <Card style={{ height: "100vh" }}>
          <CardContent
            style={{
              alignItems: "center",
              height: "80vh",
              overflowY: "auto",
            }}
          >
            <div
              style={{
                height: "100vh",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  fontSize: "80",
                  fontWeight: "bold",
                  padding: "0px 0px 10px 0px",
                  position: "sticky",
                  top: "0",
                  color: "grey",
                  backgroundColor: "white",
                  zIndex: "1",
                }}
              > 
                <div style={{ flex: "1", padding: "0 10px" }}>Symbol</div>
                {/* <div style={{ flex: "1", padding: "0 10px" }}>RL1</div>
                <div style={{ flex: "1", padding: "0 10px" }}>SL1</div> */}
                <div style={{ flex: "1", padding: "0 10px" }}>PP</div>
              </div>
              <div style={{ flex: "1", overflowY: "auto" }}>
                {
                  filterData &&
                    filterData.length !== 0 &&
                    // jsonData.map((exchangeData, index) => (
                    //   <div key={index}>
                    filterData.map((values, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          fontSize: "16px",
                          borderBottom: "1px solid grey",
                          padding: "20px 0px 20px 0px",
                        }}
                      >
                        <div style={{ flex: "1" }}>{values.Ticker}</div>
                        {/* <div style={{ flex: "1" }}>
                            {values.ResistanceLevel1}
                          </div>
                          <div style={{ flex: "1" }}>
                            {values.SupportLevel1}
                          </div> */}
                        <div style={{ flex: "1" }}>{values.Pp}</div>
                        <div onClick={() => handleShowDetails(values)}>
                          <ChevronRightIcon />
                        </div>
                      </div>
                    ))
                  //}
                  // </div>
                  //)
                  // )
                }
              </div>
            </div>
          </CardContent>
        </Card>
      ) : null}

      {showdetails ? (
        <Card
          style={{
            border: "1px solid green",
            height: "99vh",
            overflowY: "auto",
          }}
        >
          <div>
            <div>
              <Button
                style={{
                  display: "flex",
                  fontWeight: "bold",
                  fontSize: "medium",
                }}
                onClick={() => handleShowDetails1()}
              >
                Close
              </Button>
            </div>
          </div>
          <CardContent>
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
              <h3>{selectedTick.Ticker.toUpperCase()}</h3>
            </div>
            <div
              style={{
                fontSize: "16px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  margin: "10px",
                }}
              >
                <div>Pivot Point</div>
                <div>{selectedTick.Pp}</div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  margin: "10px",
                }}
              >
                <div>Resistance Level</div>
                <div>{selectedTick.ResistanceLevel1}</div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  margin: "10px",
                }}
              >
                <div>Resistance Level 2</div>
                <div> {selectedTick.ResistanceLevel2}</div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  margin: "10px",
                }}
              >
                <div>Resistance Level 3</div>
                <div> {selectedTick.ResistanceLevel3}</div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  margin: "10px",
                }}
              >
                <div>Support Level 1</div>
                <div>{selectedTick.SupportLevel1}</div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  margin: "10px",
                }}
              >
                <div>Support Level 2</div>
                <div>{selectedTick.SupportLevel2}</div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px",
                  margin: "10px",
                }}
              >
                <div>Support Level 3</div>
                <div>{selectedTick.SupportLevel3}</div>
              </div>
            </div>
          </CardContent>
        </Card>
      ) : null}
    </div>
  );
};

export default Rsl;
